import {
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ImageMasterService } from "src/app/Common/ImageMasterService/image-master.service";
import { NotificationMasterCreateRequestDTO } from "src/app/Common/NotificationMaster/notificationMaster.interface";
import { NotificationMasterService } from "src/app/Common/NotificationMaster/notificationMaster.service";
import {
  ERPEntityMappingDTO,
  ERPEntityMappingReadByMasterRequestDTO,
  ERPTicketActivityCreateRequestDTO,
  supportTicketCreateRequestDTO,
} from "src/app/erp/ERPEntityMapping.interface";
import { ERPEntityMappingService } from "src/app/erp/ERPEntityMapping.service";
import {
  HospitalMasterDTO,
  HospitalMasterReadByIdRequestDTO,
} from "src/app/hospital/BackOffice/hospital-master/hospital-master.interface";
import { HospitalMasterService } from "src/app/hospital/BackOffice/hospital-master/hospital-master.service";
import { HospitalUserAffiliationReadByUserIdRequestDTO } from "src/app/hospital/HospitalUserMapping/user-affiliation-mapping.interface";
import { HospitalUserAffiliationService } from "src/app/hospital/HospitalUserMapping/user-affiliation-mapping.service";
import { UserLoginService } from "src/app/login/userlogin.service";
import { softwareSupportTicketEmail } from "src/app/notificationTemplates/hospital/email";
import {
  SchoolMasterDTO,
  SchoolMasterReadByIdRequestDTO,
} from "src/app/School/BackOffice/school-master/school-master.interface";
import { SchoolMasterService } from "src/app/School/BackOffice/school-master/school-master.service";
import { UserAffiliationMappingReadByUserIdRequestDTO } from "src/app/School/SchoolUserMapping/user-affiliation-mapping.interface";
import { UserAffiliationMappingService } from "src/app/School/SchoolUserMapping/user-affiliation-mapping.service";
import { environment } from "src/environment/environment";

@Component({
  selector: "app-support-action",
  templateUrl: "./support-action.component.html",
  styleUrls: ["./support-action.component.css"],
})
export class SupportActionComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}

  @Input() windowType: string = "main";

  private userLoginService = inject(UserLoginService);

  // ✅ Changed: keep your User variable, but allow null-safe refresh in ngOnInit
  private User: any = this.userLoginService.User();

  private toastr = inject(ToastrService);
  private notificationMasterServices = inject(NotificationMasterService);
  private erpEntityMappingService = inject(ERPEntityMappingService);
  private hospitalMasterService = inject(HospitalMasterService);
  private schoolMasterService = inject(SchoolMasterService);
  private imgUploadService = inject(ImageMasterService);

  private hospitalUserAffiliationMapping = inject(
    HospitalUserAffiliationService
  );
  private schoolUserAffiliationMapping = inject(UserAffiliationMappingService);

  @ViewChild("chatWrapper") chatWrapper!: ElementRef;

  hospitalInfo: HospitalMasterDTO | null = null;
  schoolInfo: SchoolMasterDTO | null = null;
  erpMappingInfo: ERPEntityMappingDTO | null = null;
  attachedFile: File | null = null;

  isChatOpen = false;
  private isChatLoaded = false;
  supportOption: "ticket" | "talk" | "" = "";
  selectedIssue: string = "";

  enteredIssue = new FormControl("");

  suggestedIssues = [
    "Unable to log in or session expired.",
    "Page or module is not loading properly.",
    "Form submission is failing.",
    "Data changes are not getting saved.",
    "Updated information is not reflecting.",
    "Access or permission issue for this feature.",
    "Unexpected error or warning message appears.",
    "Notifications or alerts are not being received.",
  ];

  ngOnInit(): void {
    // ✅ FIX: refresh user again when component loads
    this.User = this.userLoginService.User();

    // ✅ FIX: stop error - Cannot read properties of null (reading 'roleId')
    if (!this.User) {
      return;
    }

    // ✅ FIX: roleId null/undefined safe
    if (Number(this.User?.roleId || 0) === 1) return;

    const url = this.router.url;
    const lowerUrl = url.toLowerCase();

    // ✅ FIX: userId null/undefined safe
    const userId = Number(this.User?.userId || 0);
    if (!userId) {
      return;
    }

    // ✅ FIX: userName null/undefined safe
    const userName = this.User?.userName?.toLowerCase() || "";

    if (
      lowerUrl.includes("hospital") ||
      userName.includes("hospital")
    ) {
      this.getUserAffiliationByUserIdForHospital(userId);
    } else if (
      lowerUrl.includes("school") ||
      userName.includes("school")
    ) {
      this.getUserAffiliationByUserIdForSchool(userId);
    }
  }

  getUserAffiliationByUserIdForHospital(userId: number) {
    const data: HospitalUserAffiliationReadByUserIdRequestDTO = {
      userId,
    };

    this.hospitalUserAffiliationMapping
      .HospitalUserAffiliationReadByUserId(data)
      .subscribe({
        next: (res) => {
          // ✅ FIX: items check before reading res.items[0]
          if (res?.items?.length > 0) {
            this.getHospitalInfoByHospitalId(res.items[0].hospitalId);
            // this.getCompanyInfoByMaster("Hospital", res.items[0].hospitalId);
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getUserAffiliationByUserIdForSchool(userId: number) {
    const data: UserAffiliationMappingReadByUserIdRequestDTO = {
      userId,
    };

    this.schoolUserAffiliationMapping
      .UserAffiliationMapping_ReadByUserId(data)
      .subscribe({
        next: (res) => {
          // ✅ FIX: items check before reading res.items[0]
          if (res?.items?.length > 0) {
            this.getSchoolInfoBySchoolId(res.items[0].schoolId);
            this.getCompanyInfoByMaster("School", res.items[0].schoolId);
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getHospitalInfoByHospitalId(hospitalId: number) {
    const data: HospitalMasterReadByIdRequestDTO = {
      hospitalId,
    };

    this.hospitalMasterService.HospitalMaster_ReadById(data).subscribe({
      next: (res) => {
        this.hospitalInfo = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getSchoolInfoBySchoolId(schoolId: number) {
    const data: SchoolMasterReadByIdRequestDTO = {
      schoolId,
    };

    this.schoolMasterService.SchoolMaster_ReadById(data).subscribe({
      next: (res) => {
        this.schoolInfo = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getCompanyInfoByMaster(masterType: string, masterId: number) {
    const payload: ERPEntityMappingReadByMasterRequestDTO = {
      masterType,
      masterId,
    };

    this.erpEntityMappingService
      .ERPEntityMapping_ReadByMasterId(payload)
      .subscribe({
        next: (res) => {
          // ✅ FIX: items check before reading res.items[0]
          if (res?.items?.length > 0) {
            this.erpMappingInfo = res.items[0];
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event) {
    if (
      this.chatWrapper &&
      !this.chatWrapper.nativeElement.contains(event.target)
    ) {
      this.isChatOpen = false; // click outside → close
    }
  }

  onWrapperClick(event: Event) {
    event.stopPropagation(); // clicking inside wrapper won't close it
  }

  toggleChat(event: Event) {
    event.stopPropagation(); // prevent bubbling
    this.isChatOpen = !this.isChatOpen;
  }

  selectOption(type: "ticket" | "talk" | "") {
    this.supportOption = type;

    if (this.isChatOpen === true && type === "talk" && !this.isChatLoaded) {
      setTimeout(() => this.loadTawk(), 0);
    }
  }

  private loadTawk() {
    (window as any).Tawk_API = (window as any).Tawk_API || {};
    (window as any).Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = "https://embed.tawk.to/6871f2a0d98e57190d02728b/1ivuhnhem";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    s1.onload = () => {
      (window as any).Tawk_API.embedded = "tawk-container";
    };

    document.body.appendChild(s1);
    this.isChatLoaded = true;
  }

  backButton() {
    if (this.selectedIssue) {
      this.selectedIssue = "";
    } else if (!this.selectedIssue) {
      this.supportOption = "";
    }
  }

  /* raise ticket TS */

  onIssueSelect(index: number = -1) {
    if (index === -1) {
      this.selectedIssue = this.enteredIssue.value as string;
    } else {
      this.selectedIssue = this.suggestedIssues[index];
    }

    this.userInfoForm.reset();
    this.attachedFile = null;
  }

  userInfoForm = new FormGroup({
    userName: new FormControl("", [Validators.required]),
    email: new FormControl("", [Validators.required, Validators.email]),
    contactNumber: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[6-9]\d{9}$/),
    ]),
  });

  submitForm() {
    this.userInfoForm.markAllAsTouched();

    if (this.userInfoForm.valid) {
      this.raiseSupportTicket();
    }
  }

  async raiseSupportTicket() {
    // const payload: supportTicketCreateRequestDTO = {
    //   projectId: 0,
    //   companyId: erpMappingInfo.erpId,
    //   branchId: erpMappingInfo.branchId,
    //   ticketNo: "",
    //
    //   ticketCompanyId: erpMappingInfo.erpId,
    //
    //   title: this.selectedIssue,
    //   tDesc: this.selectedIssue,
    //   tType: "Onboarding document upload issue",
    //   category: "",
    //   tagList: "",
    //   ticketOwner: "",
    //   assignedTo: "",
    //   ticketStatus: "Open",
    //   tPriority: "",
    //   affectsCustomer: "false",
    //   appVersion: "",
    //
    //   dueDate: new Date(),
    //   estimatedDuration: "",
    //   actualDuration: "",
    //   targetDate: new Date(),
    //   resolutionDate: new Date(),
    //
    //   department: erpMappingInfo.masterType,
    //   raisedBy: this.hospitalInfo
    //     ? this.hospitalInfo.hospitalName
    //     : this.schoolInfo
    //     ? this.schoolInfo.schoolName
    //     : "",
    //
    //   addField3: "",
    //   addField4: "",
    //   addField5: "",
    //
    //   fromCompanyId: erpMappingInfo.erpId,
    //   toCompanyId: environment.nishwikCompanyId,
    //
    //   otherDetail1: "",
    //   otherDetail2: "",
    //   otherDetail3: "",
    //   otherDetail4: "",
    //   otherDetail5: "",
    //   otherDetail6: "",
    //
    //   actionUser: "1",
    // };

    // this.erpEntityMappingService.ERPSupportTicket_Create(payload).subscribe({
    //   next: async (res) => {
    //     this.toastr.success(
    //       "Your ticket successfully raised to Nishwik support tream"
    //     );
    //
    //     if (this.attachedFile) {
    //       const filePath = await this.uploadDocumentAndStoreURL(
    //         this.attachedFile
    //       );
    //
    //       const payload: ERPTicketActivityCreateRequestDTO = {
    //         ticketId: res.ticketId,
    //         ticketComments: `<img src='${filePath}'/>`,
    //         actionUser: "Not Login",
    //       };
    //
    //       this.erpEntityMappingService
    //         .ERPTicketActivity_Create(payload)
    //         .subscribe({
    //           next: (res) => {
    //             console.log("attached file response", res);
    //             this.attachedFile = null;
    //           },
    //           error: (err) => {
    //             console.log(err);
    //           },
    //         });
    //     }
    //
    //     this.selectedIssue = "";
    //   },
    //   error: (err) => {
    //     console.log(err);
    //   },
    // });

    let uploadedFile = "";

    if (this.attachedFile) {
      uploadedFile = await this.uploadDocumentAndStoreURL(this.attachedFile);
    }

    const instituteName =
      this.hospitalInfo?.hospitalName ||
      this.schoolInfo?.schoolName ||
      "Nishwik User";

    const nContent = await softwareSupportTicketEmail(
      this.selectedIssue,
      instituteName,
      this.userInfoForm.value,
      uploadedFile ? uploadedFile : null
    );

    const data: NotificationMasterCreateRequestDTO = {
      alertConfigId: environment.alertConfigId,
      nType: "Email",
      nSubject: `Support Ticket: ${instituteName}`,
      nContent: nContent,
      nTo: "globalnishwikdev@gmail.com",
      nCc: "",
      nBcc: "",
      nStatus: "Pending",
      remarks: "",
      attachmentPath: "",
      scheduleddate: new Date(),
      retryCount: 1,
      retryDate: new Date(),
      postSendDataSourceType: "",
      postSendDataSourceDef: "",
      dbConnId: 0,
      actionUser: "Not Login",
    };

    this.notificationMasterServices
      .NotificationMaster_ExternalCreate(data)
      .subscribe({
        next: (res) => {
          this.toastr.success(
            "Your issue has been shared with our support team. We'll get back to you shortly. 🎉"
          );
          this.selectedIssue = "";
        },
        error: (err) => {
          console.log("err", err);
        },
      });
  }

  /*File Upload functions */

  onFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.attachedFile = input.files[0];
    }

    input.value = "";
  }

  uploadDocumentAndStoreURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      this.imgUploadService.ImageMaster_ExternalUpload(file).subscribe({
        next: (res) => {
          const imgURL = res.fileURL;
          resolve(imgURL);
        },
        error: (err) => {
          console.log(err);
          reject(err);
        },
      });
    });
  }
}